import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import AuthorizedTenantElement from "@/common/components/Auth/AuthorizedTenantElement";
import { ViewVariant } from "@/common/ts/layout";
import { EntityType, VehicleDto } from "@/core/api/generated/v1";

import GeneralHistoryPaginatedList from "../../../GeneralHistory/ListView/GeneralHistoryPaginatedList";

interface Props {
  vehicle: VehicleDto;
}

export default function GeneralHistoryTabContent({ vehicle }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock>
        <AuthorizedTenantElement
          tenantIdsAny={[vehicle?.tenantId, vehicle?.ownerTenantId]}
          withAlert
        >
          <GeneralHistoryPaginatedList
            defaultValues={{
              subjectEntityType: EntityType.Vehicle,
              subjectEntityId: vehicle.id,
            }}
            displayProps={{
              viewVariant: ViewVariant.Tab,
            }}
          />
        </AuthorizedTenantElement>
      </ViewContentBlock>
    </PageTabContent>
  );
}
